import store from "../../../../store/Store";

const util = {
    getAuth() {
        return {
            authorization: localStorage.getItem('access_token'),
            'Content-Type': 'application/json',
            accept: 'application/json'
        };
    },
    authenticatedRoute(to, from, next) {
        if (!store.getters.isAuthenticated) {
            next('/');
            return;
        }
        next();
    }
};

export default util;
